import React from 'react';
import {
  Card,
  Typography,
  Space,
  Tag,
  Button,
  Divider,
  message,
  Alert,
  Row,
} from 'antd';
import {
  CloseCircleTwoTone,
  CopyOutlined,
  ReloadOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons';
import { useSearchParams, Link } from 'react-router-dom';
import useRouterWithLang from '../../core/hooks/useRouterWithLang';
import { AppRouteKey } from '../../core/utilities/router';

const { Text, Title } = Typography;

export default function RegisterActivationFail() {
  const [params] = useSearchParams();
  const userId = params.get('userId') || '';
  const fullName = params.get('userNameSurname') || '';
  const reason =
    params.get('reason') ||
    'Doğrulama bağlantısı geçersiz veya süresi dolmuş olabilir.';
  const { provideUrl } = useRouterWithLang();
  const copy = async (val: string, label: string) => {
    try {
      await navigator.clipboard.writeText(val);
      message.success(`${label} kopyalandı`);
    } catch {
      message.error('Kopyalama başarısız');
    }
  };

  return (
    <Card
      style={{ maxWidth: 460, borderRadius: 16 }}
      bodyStyle={{ padding: 18 }}
    >
      <Space direction="vertical" size={10} style={{ width: '100%' }}>
        <Space align="center">
          <CloseCircleTwoTone twoToneColor="#ff4d4f" style={{ fontSize: 22 }} />
          <Title level={4} style={{ margin: 0 }}>
            Aktivasyon başarısız
          </Title>
        </Space>

        <Alert
          type="error"
          showIcon
          message="Hesap şu anda etkinleştirilemedi."
          description={reason}
        />

        <Divider style={{ margin: '10px 0' }} />

        <Space direction="vertical" size={6} style={{ width: '100%' }}>
          <Space align="baseline" wrap>
            <Text type="secondary">İlgili kullanıcı:</Text>
            <Tag style={{ marginInlineStart: 6 }}>{fullName || '-'}</Tag>
            {!!fullName && (
              <Button
                size="small"
                type="text"
                icon={<CopyOutlined />}
                onClick={() => copy(fullName, 'Ad Soyad')}
              />
            )}
          </Space>

          <Space align="baseline" wrap>
            <Text type="secondary">Kullanıcı ID:</Text>
            <Tag color="default" style={{ marginInlineStart: 6 }}>
              {userId || '-'}
            </Tag>
            {!!userId && (
              <Button
                size="small"
                type="text"
                icon={<CopyOutlined />}
                onClick={() => copy(userId, 'Kullanıcı ID')}
              />
            )}
          </Space>
        </Space>

        <Divider style={{ margin: '10px 0' }} />

        {/*<Space style={{ width: '100%' }}>*/}
        {/*  /!* Tekrar dene: sistemine göre hedefi düzenle *!/*/}
        <Row className="justify-center">
          <Button type="primary">
            <Link to={provideUrl(AppRouteKey.HOME)}>Ana Sayfa</Link>
          </Button>
        </Row>

        {/*  /!* Destek sayfasına yönlendirme örneği *!/*/}
        {/*  <Button>*/}
        {/*    <Link to="/support">Destek ile iletişime geç</Link>*/}
        {/*  </Button>*/}
        {/*</Space>*/}

        <Text type="secondary" style={{ fontSize: 12 }}>
          Eğer sorun devam ederse, lütfen destek ekibimize hata mesajı veya
          ekran görüntüsüyle birlikte ulaşın.
        </Text>
      </Space>
    </Card>
  );
}
